import logowhite from "@assets/img/logo/logo-simple.png";
import background from "@assets/img/auth/customer/background.png";
import { Button } from "@components/buttons/button";
import { Input } from "@components/forms/input";
import { InputGroup } from "@components/forms/input-group";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuthContext } from "@hooks/contexts/auth-context";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

interface IFormValues {
  userName: string;
  password: string;
  termsCheck: boolean;
}

export function Auth() {
  const scheme = yup.object().shape({
    userName: yup.string().required("E-mail é obrigatório"),
    password: yup.string().required("Senha é obrigatório"),
  });

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormValues>({
    resolver: yupResolver(scheme) as any,
    mode: "onSubmit",
    reValidateMode: "onBlur",
  });

  const { signIn } = useAuthContext();

  async function handleLogin(data: IFormValues) {
    await signIn(data);
  }

  function handleKeyPress(event: KeyboardEvent) {
    if (event.key === "Enter") {
      const activeElement = document.activeElement;
      if (
        activeElement instanceof HTMLInputElement ||
        activeElement instanceof HTMLTextAreaElement
      ) {
        activeElement.blur();
      }
      event.preventDefault();
      handleSubmit(handleLogin)();
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row vh-100">
          <div
            className="col-md-7"
            style={{
              backgroundImage: `url(${background})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>

          <div
            className="col-md-5"
            style={{
              backgroundColor: "#000",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <div className="row gap-3">
              <img
                className="img-fluid"
                src={logowhite}
                style={{
                  height: "30vh",
                }}
              />

              <span className="h2 text-white d-flex justify-content-center">
                Área do Cliente
              </span>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit(handleLogin)();
                }}
              >
                <div className="row gap-1 px-3">
                  <div className="col-md-12">
                    <Input
                      label="Nome de Usuário"
                      id={`userName`}
                      name={`userName`}
                      placeholder="Username ou E-mail"
                      showLabel={false}
                      type="text"
                      register={register("userName")}
                      errorMessage={errors?.userName?.message}
                    />
                  </div>

                  <div className="col-md-12">
                    <InputGroup
                      label="Senha"
                      id={`password`}
                      name={`password`}
                      placeholder="*********"
                      type="password"
                      register={register("password")}
                      errorMessage={errors?.password?.message}
                    />
                  </div>

                  <div className="col-md-12">
                    <Button
                      children="Entrar"
                      className="btn btn-secondary w-100 py-3"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
